module.exports = __webpack_public_path__ + "static/media/twelveth_miller_house.259327fb.mp4";